import { message as antdMessage } from "antd";
import { CodeConstant } from "../../../../constants";
import * as dashboardService from "../../../../services/Dashboard";
import * as onboardingService from "../../../../services/Onboarding";
import { pushLog2DV2LogServer } from "../../../../services/logging";
import { BasicProfileApiActions, VALIDATE_BASIC_INFO_PAGE_DATA, basicInformationReduxAction } from "./BasicInformation/basicInformation.action";
import {
  SELECT_TOP_SKILLS_BY_PRIORITY,
  VALIDATE_ROLE_SKILL_PAGE_DATA,
  roleAndTechSkillReduxActions,
} from "./RoleAndTechSkills/roleAndTechSkills.action";
import { EducationActions, EducationReduxActionTypes, VALIDATE_EDUCATION_PAGE_DATA } from "./Education/Education.actions";
import publicIp from "public-ip";
import { groupRolesByRoleGroup } from "../../../util/groupJobRolesByRoleGroup";
import { ResumeUploadAction } from "./NewResumeUpload/constants";
import { validateEducation } from "./Education/validation";
import { validateLinks } from "./AdditionalInformation/Links/validation";
import { validatePublications } from "./AdditionalInformation/Publications/validation";


const UPDATE_ERRORS = (page, errors) => (dispatch) => {
  dispatch({
    type: OnboardingNewUiUxReduxActions.UPDATE_ERROR_DATA,
    payload: { page, errors },
  });
};

export const OnboardingNewUiUxReduxActions = {
  SET_CURRENT_STEP: "SET_CURRENT_STEP",
  UPDATE_STATE_DATA: "UPDATE_STATE_DATA",
  USED_LINKEDIN_OR_RESUME: "USED_LINKEDIN_OR_RESUME",
  UPDATE_SECTION_VALUES: "UPDATE_SECTION_VALUES",
  RESET_STORE: "RESET_STORE",
  UPDATE_ERROR_DATA: "UPDATE_ERROR_DATA",
  MARK_STEP_AS_VISITED: "MARK_STEP_AS_VISITED",
  SET_JOBS_LOADING: 'SET_JOBS_LOADING',
  FETCH_JOBS_REMAINING: 'FETCH_JOBS_REMAINING',
  SET_FORECASTED_JOBS: 'SET_FORECASTED_JOBS',
  FORM_SUBMITTING: 'FORM_SUBMITTING',
  MARK_RESUME_UPLOAD_BANNER_AS_CLOSED: 'MARK_RESUME_UPLOAD_BANNER_AS_CLOSED',
  FETCHED_SOCIAL_PROOF_INFO: 'FETCHED_SOCIAL_PROOF_INFO',
  UPDATE_ERRORS,
};

const GET_RECOMMENDED_JOBS_FOR_LOW_SUPPLY = (body) => async (dispatch) => {
  dispatch({ type: OnboardingNewUiUxReduxActions.FORM_SUBMITTING, payload: true })
  try {
    const result = await onboardingService.getRecommendedJobForLowSupply(body);
    if (result.data.success) {
      const { matchedOpportunities } = result.data;
      if (matchedOpportunities && matchedOpportunities.length > 0) {
        const randomOpportunity =
          matchedOpportunities[
            Math.floor(Math.random() * matchedOpportunities.length)
            ];
        localStorage.setItem(
          "jobOppurtunityModalConfig",
          JSON.stringify(randomOpportunity)
        );
      }
    } else {
      dispatch({ type: OnboardingNewUiUxReduxActions.FORM_SUBMITTING, payload: false })
    }
    dispatch(FETCH_JOBS_DATA_AFTER_ONBOARDING);
  } catch (e) {
    antdMessage.error(e.response.data.message);
    dispatch({ type: OnboardingNewUiUxReduxActions.FORM_SUBMITTING, payload: false })
    // Handle errors and log them
    const { errorCode, message, stack } = e;
    pushLog2DV2LogServer.error(
      "ONBOARDING_NEW_UI_UX",
      "GET_RECOMMENDED_JOBS_FOR_LOW_SUPPLY",
      {},
      {},
      { errorCode, message, stack }
    );
  }
};

const FETCH_JOBS_DATA_AFTER_ONBOARDING = (callback=null) => async (dispatch) => {
  try {
    dispatch({ type: OnboardingNewUiUxReduxActions.FORM_SUBMITTING, payload: true })
    dispatch({
      type: OnboardingNewUiUxReduxActions.SET_JOBS_LOADING,
      payload: "loading",
    });
    const res = await dashboardService.developerSignupCompleted();
    if (res.data) {
      localStorage.setItem('flagTime', `${new Date()}`);
      localStorage.setItem('flagNewUser', 'true');
      localStorage.setItem('modalDisplayed', false);
    }
    dispatch({
      type: OnboardingNewUiUxReduxActions.SET_FORECASTED_JOBS,
      payload: res.data.forecastedJobId,
    });

    dispatch({
      type: OnboardingNewUiUxReduxActions.SET_JOBS_LOADING,
      payload: "finished",
    });

    dispatch({
      type: OnboardingNewUiUxReduxActions.FETCH_JOBS_REMAINING,
      payload: "finished",
    });
    dispatch({ type: OnboardingNewUiUxReduxActions.FORM_SUBMITTING, payload: false })
  } catch (err) {
    dispatch({
      type: OnboardingNewUiUxReduxActions.SET_JOBS_LOADING,
      payload: null,
    });

    dispatch({
      type: OnboardingNewUiUxReduxActions.FETCH_JOBS_REMAINING,
      payload: null,
    });
    dispatch({ type: OnboardingNewUiUxReduxActions.FORM_SUBMITTING, payload: false })

    antdMessage.error(err.response?.data?.message || 'Unexpected error occurred');

    // Handle errors and log them
    const { errorCode, message, stack } = err;
    pushLog2DV2LogServer.error(
      "ONBOARDING",
      "FETCH_BASIC_INFO",
      {},
      {},
      { errorCode, message, stack }
    );
  } finally {
    if (callback && typeof callback === 'function') callback()
  }
};

const FETCH_BASIC_INFO = (roles_to_skip, fetch_dependent_data = true) => async (dispatch) => {
  try {
    dispatch({ type: OnboardingNewUiUxReduxActions.UPDATE_STATE_DATA, payload: { basicInfoDataFetched: false } });
    const result = await dashboardService.getBasicInfo();
    if (result.data.success) {
      const userInfo = result.data.result[0] || {};
      const name = userInfo.full_name ? userInfo.full_name.split(' ') : [];
      const firstName = name.length > 0 ? name[0] : null;
      const lastName = name.length > 1 ? name[1] : null;
      const role_skills_page_data = {
        job_role_id: userInfo.role_type_id || undefined,
        yearsOfExperience: userInfo.years_of_experience
      }
      const linkedInUrl = userInfo.linkedin_url;
      dispatch({
        type: roleAndTechSkillReduxActions.UPDATE_ROLE_TECH_SKILLS_STATE_DATA,
        payload: role_skills_page_data
      })
      const basic_info_data = {
        firstName,
        lastName,
        country_id: userInfo.country_id || undefined,
        phoneCountry: userInfo.phone_country_code ? userInfo.phone_country_code : userInfo.code,
        expected_salary: userInfo.expected_salary,
        phoneNumber: userInfo.phone_number,
        city_of_residence: userInfo.city_of_residence,
        salary_local_currency: userInfo.salary_local_currency
      }
      if (userInfo.resume || userInfo.linkedin_url) {
        dispatch({ type: OnboardingNewUiUxReduxActions.USED_LINKEDIN_OR_RESUME })
      }
      dispatch({ type: basicInformationReduxAction.UPDATE_BASIC_INFO_STATE_DATA, payload: basic_info_data })
      dispatch({
        type: OnboardingNewUiUxReduxActions.UPDATE_SECTION_VALUES,
        payload: { page: 'basic_profile_page', values: basic_info_data }
      });
      dispatch({
        type: OnboardingNewUiUxReduxActions.UPDATE_SECTION_VALUES,
        payload: { page: 'role_skills_page', values: role_skills_page_data }
      });
      dispatch({
        type: ResumeUploadAction.UPDATE_LINKEDIN_URL,
        payload: linkedInUrl,
      });

      if (fetch_dependent_data) {
        dispatch(FETCH_JOB_ROLE_TYPE(userInfo.role_type_id, roles_to_skip))
        dispatch(FETCH_SKILLS_BY_ROLE(userInfo.role_type_id))
      }
    }
  } catch (e) {
    // Handle errors and log them
    const { errorCode, message, stack } = e;
    pushLog2DV2LogServer.error('ONBOARDING', 'FETCH_BASIC_INFO', {}, {}, { errorCode, message, stack });
  }
  dispatch({ type: OnboardingNewUiUxReduxActions.UPDATE_STATE_DATA, payload: { basicInfoDataFetched: true } });
  dispatch(VALIDATE_STEP_DATA('basic_profile_page'))
  dispatch(VALIDATE_STEP_DATA('role_skills_page'))
}

/**
 * Fetch last visited step
 */
const GET_LAST_VISITED_STEP = callback => async dispatch => {
  try {
    const stepDetails = await dashboardService.getLastVisitedStep();
    if (stepDetails.data) {
      const currentStep = stepDetails.data.last_visited_step;
      if (callback && currentStep) {
        dispatch({
          type: OnboardingNewUiUxReduxActions.MARK_STEP_AS_VISITED,
          payload: "basic_profile_page",
        });
        dispatch({
          type: OnboardingNewUiUxReduxActions.MARK_STEP_AS_VISITED,
          payload: "education_page",
        });
        dispatch({
          type: OnboardingNewUiUxReduxActions.MARK_STEP_AS_VISITED,
          payload: "role_skills_page",
        });
        dispatch(callback(currentStep))
      }
    }
  } catch (e) {
    const { errorCode, message, stack } = e;
    pushLog2DV2LogServer.error('ONBOARDING', 'GET_LAST_VISITED_STEP', {}, {}, { errorCode, message, stack }); 
  }
}


/**
 * Fetch job role types from the server
 * @param {number} user_role_id - User role ID
 * @returns {Function} - Redux Thunk function for asynchronous action
 */
const FETCH_JOB_ROLE_TYPE = (user_role_id, roles_to_skip = []) => async dispatch => {
  try {
    const { data } = await dashboardService.getJobRoleType();
    if (data.success) {
      // Filter out unwanted roles and map them
      let roleConstant = data.result
        .filter(role => !roles_to_skip.includes(role.id))
      const selectedRole = roleConstant.find(role => role.id === user_role_id);
      // Get label for the selected role
      const role_label = selectedRole ? selectedRole.role_type : null;
      roleConstant = groupRolesByRoleGroup(roleConstant);
      // Dispatch action to update Redux state with job roles
      dispatch({
        type: roleAndTechSkillReduxActions.UPDATE_ROLE_TECH_SKILLS_STATE_DATA,
        payload: { jobRoles: roleConstant, job_role_text: role_label }
      });
      dispatch({
        type: OnboardingNewUiUxReduxActions.UPDATE_SECTION_VALUES,
        payload: { page: 'role_skills_page', values: { job_role_text: role_label } }
      })
      // Log the action
      pushLog2DV2LogServer.info('ONBOARDING', 'GET_JOB_ROLE_TYPE', {}, { jobRoles: roleConstant }, null);
      return roleConstant;
    }
  } catch (e) {
    // Handle errors and log them
    const { errorCode, message, stack } = e;
    pushLog2DV2LogServer.error('ONBOARDING', 'GET_JOB_ROLE_TYPE', {}, {}, { errorCode, message, stack });
  }
};

/**
 * Fetch skills by role from the server
 * @param {number} role_id - Role ID
 * @returns {Function} - Redux Thunk function for asynchronous action
 */
const FETCH_SKILLS_BY_ROLE = role_id => async dispatch => {
  try {
    const { data } = await onboardingService.fetchRoleSkillsMappingData();
    if (data.success && data.data && data.data.roles) {
      // Select top skills for the given role id
      const selected_role_skills = role_id ? SELECT_TOP_SKILLS_BY_PRIORITY(role_id, data.data.roles) : [];
      // Dispatch action to update Redux state with skills by role data
      dispatch({
        type: roleAndTechSkillReduxActions.UPDATE_ROLE_TECH_SKILLS_STATE_DATA,
        payload: { skills_by_role_data: data.data.roles, selected_role_skills }
      });
      // Log the action
      pushLog2DV2LogServer.info('ONBOARDING', 'FETCH_SKILLS_BY_ROLE', {}, { data: data.data.roles }, null);
    }
  } catch (e) {
    // Handle errors and log them
    const { errorCode, message, stack } = e;
    pushLog2DV2LogServer.error('ONBOARDING', 'FETCH_SKILLS_BY_ROLE', {}, {}, { errorCode, message, stack });
  }
};

/**
 * Fetch all base skills from the server
 * @param {boolean} get_canonical_skills - Flag to get canonical skills
 * @returns {Function} - Redux Thunk function for asynchronous action
 */
const FETCH_ALL_BASE_SKILLS = async dispatch => {
  try {
    const { data } = await onboardingService.getBaseAllSkillList(true);
    if (data.success) {
      // Extract all skills data
      const { result: all_skills } = data;
      // Dispatch action to update Redux state with all skills
      dispatch({ type: roleAndTechSkillReduxActions.UPDATE_ROLE_TECH_SKILLS_STATE_DATA, payload: { all_skills } });
      // Log the action
      pushLog2DV2LogServer.info('ONBOARDING', 'FETCH_ALL_BASE_SKILLS', {}, { all_skills }, null);
    }
  } catch (e) {
    // Handle errors and log them
    const { errorCode, message, stack } = e;
    pushLog2DV2LogServer.error('ONBOARDING', 'FETCH_ALL_BASE_SKILLS', {}, {}, { errorCode, message, stack });
  }
};

const GET_DEVELOPER_SKILL_INFO = async (dispatch) => {
  try {
    const response = await dashboardService.getDeveloperSkillInfo();
    if (response.data.code === CodeConstant.OK) {
      let skill_data = response.data.data.all_skills;
      skill_data = (skill_data || []).map((skill) => ({
        id: skill.skill_id,
        skill_name: skill.skill_name,
        score: skill.score,
        row_id: skill.id,
        skill_level: skill.skill_level
      }));
      dispatch({
        type: roleAndTechSkillReduxActions.UPDATE_ROLE_TECH_SKILLS_STATE_DATA,
        payload: { selected_skills_data: skill_data }
      })
      dispatch({
        type: OnboardingNewUiUxReduxActions.UPDATE_SECTION_VALUES,
        payload: { page: 'role_skills_page', values: { selected_skills_data: skill_data } }
      });
    }
    dispatch(VALIDATE_STEP_DATA('role_skills_page'))
  } catch (e) {
    const { errorCode, message, stack } = e;
    pushLog2DV2LogServer.error('ONBOARDING', 'GET_DEVELOPER_SKILL_INFO', {}, {}, { errorCode, message, stack });
  }
};

const GET_EDUCATION_INFO = async (dispatch, getState) => {
  try {
    const { education_page } = getState().onboarding_new_ui;
    const response = await dashboardService.getEducationInfo();
    if (response.data.success && response.data.result.length) {
      const values = response.data.result.map(it => {
        const dataFromState = education_page.values.find(
          item => item.degree === it.degree || item.college === it.college
        );
        return {
          ...it,
          ...dataFromState,
          college: it.college === 'N/A' ? null : it.college,
          degree: it.degree === 'N/A' ? null : it.degree,
          start_year: (!it.start_year || it.start_year === '0') ? null : it.start_year,
          start_month: (!it.start_month || it.start_month === '0') ? null : it.start_month,
          end_year: (!it.end_year || it.end_year === '0') ? null : it.end_year,
          end_month: (!it.end_month || it.end_month === '0') ? null : it.end_month,
        }
      })
      dispatch({
        type: OnboardingNewUiUxReduxActions.UPDATE_SECTION_VALUES,
        payload: { page: 'education_page', values }
      })
    } else {
      dispatch({
        type: OnboardingNewUiUxReduxActions.UPDATE_SECTION_VALUES,
        payload: {
          page: 'education_page', values: [{
            college: "",
            country_id: "",
            degree: "",
            level: "",
            start_year: "",
            start_month: "",
            end_year: "",
            end_month: "",
            is_current: false,
          }]
        }
      })
    }
    dispatch(VALIDATE_STEP_DATA('education_page'));
  } catch (e) {
    const { errorCode, message, stack } = e;
    pushLog2DV2LogServer.error('ONBOARDING', 'GET_EDUCATION_INFO', {}, {}, { errorCode, message, stack });
  }
}

const FETCH_SOCIAL_PROOF_INFO = async (dispatch) => {
  try {
    const userIp = await publicIp.v4();
    const result = await dashboardService.getClientInformationDataByIp(userIp);
    if (result.data.data) {
      const clientInformationData = result.data.data;
      pushLog2DV2LogServer.info('SOCIAL_PROOF', 'FETCH_CLIENT_INFORMATION', { }, clientInformationData, null);
      dispatch({ type:OnboardingNewUiUxReduxActions.FETCHED_SOCIAL_PROOF_INFO, payload: clientInformationData })
    } else {
      const log_error = {
        message: `Response code from getClientInformation is ${result.status}`
      };
      pushLog2DV2LogServer.error('SOCIAL_PROOF', 'FETCH_CLIENT_INFORMATION', { }, { }, log_error);
    }
  } catch (e) {
    console.log(e.message);
    pushLog2DV2LogServer.error('SOCIAL_PROOF', 'FETCH_CLIENT_INFORMATION', { }, { }, e);
  }
}

const GET_USER_PUBLICATIONS = async (dispatch) => {
  try {
    const response = await dashboardService.getUserPublications();
    if (response.data.success) {
      dispatch({
        type: OnboardingNewUiUxReduxActions.UPDATE_SECTION_VALUES,
        payload: { page: 'publications_page', values: response.data.result }
      })
    } else {
      dispatch({
        type: OnboardingNewUiUxReduxActions.UPDATE_SECTION_VALUES,
        payload: { page: 'publications_page', values: [] }
      })
      pushLog2DV2LogServer.error('ONBOARDING', 'GET_USER_PUBLICATIONS', {}, {}, e);
    }
  } catch (e) {
    pushLog2DV2LogServer.error('ONBOARDING', 'GET_USER_PUBLICATIONS', {}, {}, e);
  }
}

const GET_USER_LINKS = async (dispatch) => {
  try {
    const response = await dashboardService.getUserLinks();
    if (response.data.success) {
      dispatch({
        type: OnboardingNewUiUxReduxActions.UPDATE_SECTION_VALUES,
        payload: { page: 'links_page', values: response.data.result }
      })
    } else {
      dispatch({
        type: OnboardingNewUiUxReduxActions.UPDATE_SECTION_VALUES,
        payload: { page: 'links_page', values: [] }
      })
      pushLog2DV2LogServer.error('ONBOARDING', 'GET_USER_LINKS', {}, {}, e);
    }
  } catch (e) {
    pushLog2DV2LogServer.error('ONBOARDING', 'GET_USER_LINKS', {}, {}, e);
  }
}

const FETCH_ALL_COUNTRIES = async (dispatch) => {
  try {
    const response = await dashboardService.getAllCountries();
    const countries = response.data.result.map(item => {
      return {
        value: item.id,
        label: item.name,
        currency: item.currency,
        isOfac: item.is_ofac
      }
    });
    const excludedCountries = response.data.result.filter(country => country.is_ofac === 1).map(item => {
      return item.code ? item.code.toLowerCase() : null;
    });
    dispatch({ type: OnboardingNewUiUxReduxActions.UPDATE_STATE_DATA, payload: { countries, excludedCountries } });
    pushLog2DV2LogServer.info('ONBOARDING', 'FETCH_ALL_COUNTRIES', {}, { countries }, null);
    return response.data.result;

  } catch (e) {
    const { errorCode, message, stack } = e;
    pushLog2DV2LogServer.error('ONBOARDING', 'FETCH_ALL_COUNTRIES', {}, {}, { errorCode, message, stack });
  }
};

const UPDATE_LAST_VISITED_STEP = lastVisitedStep => async dispatch => {
  try {
    await dashboardService.updateLastVisitedStep(lastVisitedStep);
    pushLog2DV2LogServer.info('ONBOARDING', 'UPDATE_LAST_VISITED_STEP', {}, { step }, null);
  } catch (e) {
    const { errorCode, message, stack } = e;
    pushLog2DV2LogServer.error('ONBOARDING', 'UPDATE_LAST_VISITED_STEP', {}, {}, { errorCode, message, stack });
  }
};

const GET_DEVELOPER_REFERRAL_SOURCE = async (dispatch) => {
  try {
    const response = await dashboardService.getDeveloperReferralSource();
    if (response.data.success) {
      const { ref_checked_values, ref_other_value } = response.data.result;
      if (ref_checked_values) {
        const value = ref_checked_values.split(';') || [];
        dispatch({
          type: basicInformationReduxAction.UPDATE_BASIC_INFO_STATE_DATA,
          payload: { ref_checked_values: value, ref_other_value }
        });
        dispatch({
          type: OnboardingNewUiUxReduxActions.UPDATE_SECTION_VALUES,
          payload: { page: 'basic_profile_page', values: { ref_checked_values: value, ref_other_value } }
        });
      }
      pushLog2DV2LogServer.info('ONBOARDING', 'GET_DEVELOPER_REFERRAL_SOURCE', {}, { ref_checked_values }, null);
    } else {
      antdMessage.warn('Error: unable to fetch developer referral source');
      const log_error = {
        message: 'Response code from GET_DEVELOPER_REFERRAL_SOURCE is ' + response.status + '.'
      };
      pushLog2DV2LogServer.warn('ONBOARDING', 'GET_DEVELOPER_REFERRAL_SOURCE', {}, {}, log_error);
    }
  } catch (e) {
    antdMessage.error('Error: unable to fetch developer referral source');
    pushLog2DV2LogServer.error('ONBOARDING', 'GET_DEVELOPER_REFERRAL_SOURCE', {}, {}, e);
  }
};

export const VALIDATE_EDUCATION_PAGE = (dispatch, getState) => {
  const { education_page } = getState().onboarding_new_ui;
  const errors = validateEducation(education_page.values);
  dispatch({ type: OnboardingNewUiUxReduxActions.UPDATE_ERROR_DATA, payload: { page: 'education_page', errors } });
}

export const VALIDATE_PUBLICATIONS_PAGE = (dispatch, getState) => {
  const { publications_page } = getState().onboarding_new_ui;
  const errors = validatePublications(publications_page.values);
  dispatch({ type: OnboardingNewUiUxReduxActions.UPDATE_ERROR_DATA, payload: { page: 'publications_page', errors } });
}

export const VALIDATE_LINKS_PAGE = (dispatch, getState) => {
  const { links_page } = getState().onboarding_new_ui;
  const errors = validateLinks(links_page.values);
  dispatch({ type: OnboardingNewUiUxReduxActions.UPDATE_ERROR_DATA, payload: { page: 'links_page', errors } });
}

export const VALIDATE_STEP_DATA = (page) => dispatch => {
  switch (page) {
    case 'basic_profile_page':
      return dispatch(VALIDATE_BASIC_INFO_PAGE_DATA)
    case 'education_page':
      return dispatch(VALIDATE_EDUCATION_PAGE)
    case 'role_skills_page':
      return dispatch(VALIDATE_ROLE_SKILL_PAGE_DATA)
    case 'publications_page':
      return dispatch(VALIDATE_PUBLICATIONS_PAGE)
    case 'links_page':
      return dispatch(VALIDATE_LINKS_PAGE)
    default:
      return
  }
}

/**
 * Reset all state errors on refresh on component load
 */
export const RUN_OR_RESET_PAGE_VALIDATIONS = (dispatch, getState) => {
  // Reset all current validations
  dispatch({
    type: OnboardingNewUiUxReduxActions.UPDATE_ERROR_DATA,
    payload: { page: 'basic_profile_page', errors: {} }
  });
  dispatch({ type: OnboardingNewUiUxReduxActions.UPDATE_ERROR_DATA, payload: { page: 'education_page', errors: {} } });
  dispatch({
    type: OnboardingNewUiUxReduxActions.UPDATE_ERROR_DATA,
    payload: { page: 'role_skills_page', errors: {} }
  });
  const state = getState();
  const onboarding_state = state.onboarding_new_ui;
  const { stepper } = onboarding_state;
  const basic_profile_visited = stepper.step_details.basic_profile_page.isVisited;
  const education_page_visited = stepper.step_details.education_page.isVisited;
  const role_skills_page_visited = stepper.step_details.role_skills_page.isVisited;
  if (basic_profile_visited) {
    // Run basic info validations
    dispatch(VALIDATE_BASIC_INFO_PAGE_DATA)
  }

  // if (education_page_visited) {
  //   // Call function for Education validation
  //   dispatch(VALIDATE_EDUCATION_PAGE_DATA)
  // }

  if (role_skills_page_visited) {
    // Run skill role validation
    dispatch(VALIDATE_ROLE_SKILL_PAGE_DATA)
  }
}


export const FORM_HAS_NO_ERRORS = ({ basic_profile_page, education_page, role_skills_page }) => {
  const education_page_does_not_have_error = Object.keys(education_page.hasErrors).length === 0;

  const role_skills_page_does_not_have_error = Object.keys(role_skills_page.hasErrors).length === 0;

  const basic_profile_page_does_not_have_error = Object.keys(basic_profile_page.hasErrors).length === 0;
  const none_of_the_pages_have_error =
    education_page_does_not_have_error &&
    role_skills_page_does_not_have_error
    && basic_profile_page_does_not_have_error;

  return none_of_the_pages_have_error;
}

const FETCH_ALL_LANGUAGES = async (dispatch) => {
  try {
    const response = await onboardingService.getAllLanguages();
    const languages = response?.data?.data?.languages.map(item => {
      return {
        value: item.id,
        label: item.name,
      }
    });
    dispatch({ type: roleAndTechSkillReduxActions.UPDATE_ROLE_TECH_SKILLS_STATE_DATA, payload: { languages } });
    pushLog2DV2LogServer.info('ONBOARDING', 'FETCH_ALL_LANGUAGES', {}, { languages }, null);
  } catch (e) {
    const { errorCode, message, stack } = e;
    pushLog2DV2LogServer.error('ONBOARDING', 'FETCH_ALL_LANGUAGES', {}, {}, { errorCode, message, stack });
  }
};

const FETCH_ALL_PROFICIENCY_TYPES_AND_LEVELS = async (dispatch) => {
  try {
    const response = await onboardingService.getAllProficiencyTypesAndLevels();
    dispatch({ 
      type: roleAndTechSkillReduxActions.UPDATE_ROLE_TECH_SKILLS_STATE_DATA, 
      payload: { 
        languageProficiencyTypes: [...response?.data?.data?.proficiencyTypes],
        languageProficiencyLevels: [...response?.data?.data?.proficiencyLevels] 
      } 
    });
    pushLog2DV2LogServer.info('ONBOARDING', 'FETCH_ALL_PROFICIENCY_TYPES_AND_LEVELS', {}, {}, null);
  } catch (e) {
    const { errorCode, message, stack } = e;
    pushLog2DV2LogServer.error('ONBOARDING', 'FETCH_ALL_PROFICIENCY_TYPES_AND_LEVELS', {}, {}, { errorCode, message, stack });
  }
};

const FETCH_DEVELOPER_LANGUAGE_PROFICIENCIES = async (dispatch) => {
  try {
    const response = await onboardingService.getDeveloperLanguageProficiencies();
    const { developerLanguageProficiencies } = response?.data?.data;

    const mappedDeveloperLanguageProficiencies = developerLanguageProficiencies.map((item) => {
      return {
        renderId: `temp-${Math.random()}`,
        ...item,
      }
    });

    dispatch({
      type: roleAndTechSkillReduxActions.UPDATE_ROLE_TECH_SKILLS_STATE_DATA,
      payload: { developerLanguageProficiencies: mappedDeveloperLanguageProficiencies }
    });
    dispatch({
      type: OnboardingNewUiUxReduxActions.UPDATE_SECTION_VALUES,
      payload: { page: 'role_skills_page', values: { developerLanguageProficiencies: mappedDeveloperLanguageProficiencies } }
    });
    pushLog2DV2LogServer.info('ONBOARDING', 'FETCH_DEVELOPER_LANGUAGE_PROFICIENCIES', {}, { developerLanguageProficiencies }, null);
  } catch (e) {
    const { errorCode, message, stack } = e;
    pushLog2DV2LogServer.error('ONBOARDING', 'FETCH_DEVELOPER_LANGUAGE_PROFICIENCIES', {}, {}, { errorCode, message, stack });
  }
  dispatch(VALIDATE_STEP_DATA('role_skills_page'))
};

export const RESET_STATE = (dispatch) => {
  dispatch({ type: roleAndTechSkillReduxActions.RESET_STATE_DATA });
  dispatch({ type: OnboardingNewUiUxReduxActions.RESET_STORE })
  dispatch({ type: ResumeUploadAction.RESET_STATE })
  dispatch({ type: EducationReduxActionTypes.RESET_STATE_DATA })
  dispatch({ type: basicInformationReduxAction.RESET_STATE_DATA })
}

export const ONBOARDING_API_ACTIONS = {
  FETCH_BASIC_INFO,
  FETCH_ALL_BASE_SKILLS,
  FETCH_SKILLS_BY_ROLE,
  FETCH_JOB_ROLE_TYPE,
  GET_DEVELOPER_SKILL_INFO,
  FETCH_ALL_COUNTRIES,
  GET_EDUCATION_INFO,
  GET_USER_PUBLICATIONS,
  GET_USER_LINKS,
  GET_RECOMMENDED_JOBS_FOR_LOW_SUPPLY,
  GET_DEVELOPER_REFERRAL_SOURCE,
  FETCH_JOBS_DATA_AFTER_ONBOARDING,
  FETCH_SOCIAL_PROOF_INFO,
  UPDATE_LAST_VISITED_STEP,
  GET_LAST_VISITED_STEP,
  FETCH_ALL_LANGUAGES,
  FETCH_ALL_PROFICIENCY_TYPES_AND_LEVELS,
  FETCH_DEVELOPER_LANGUAGE_PROFICIENCIES,
};
